var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6629 482.25L29.7499 482.337C32.0569 484.661 34.8006 486.506 37.8231 487.766C40.8456 489.026 44.0873 489.676 47.3619 489.679C50.1174 489.677 52.8537 489.223 55.4619 488.334L197.468 440.162L469.968 167.662C486.627 151.002 495.985 128.406 495.984 104.847C495.983 81.2867 486.623 58.6921 469.962 42.0335C453.302 25.3748 430.707 16.0167 407.147 16.0177C383.587 16.0187 360.993 25.3789 344.334 42.039L71.8339 314.539L23.6659 456.541C22.1487 460.957 21.9065 465.711 22.9672 470.258C24.0278 474.805 26.3485 478.961 29.6629 482.25ZM366.963 64.666C377.635 54.0752 392.069 48.145 407.104 48.1739C422.139 48.2028 436.551 54.1884 447.182 64.82C457.813 75.4517 463.798 89.8629 463.827 104.898C463.855 119.933 457.925 134.367 447.334 145.039L411.5 180.873L331.127 100.5L366.963 64.666ZM99.7439 331.884L308.5 123.127L388.873 203.5L180.116 412.256L58.4819 453.518L99.7439 331.884Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.0c9d70cf66f5a9271d37973b1cc77877.svg";
export { ForwardRef as ReactComponent };